import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import ScrollSmoother from "gsap/ScrollSmoother";
import SplitText from "gsap/SplitText";
import Flip from "gsap/Flip";

gsap.config({
  nullTargetWarn: false,
  force3D: "auto",
});

gsap.registerPlugin(ScrollTrigger, ScrollSmoother, SplitText, Flip);

export function prefersReducedMotion() {
  if (typeof window === "undefined") return false;
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}
